import {
  IAmplifyConfigData,
  IAmplifyConfigDataNewSetUp,
  IAmplifyGoConfigData,
  IAmplifySSOConfigData,
  IAmplifyZpaxSSOConfigData,
  IAmplifyMicrosoftSSOConfigData,
} from "../../../../config";

enum configureTypes {
  LAMBDA = "lambda",
  FAST = "fast",
  GO = "go",
  SSO = "sso",
  ZPAX_SSO = "zpax_sso",
  MICROSOFT_SSO = "microsoft_sso",
}

export type IAmplifyProvider = ReturnType<typeof AmplifyProviderFactory>;

export const AmplifyProviderFactory = ({
  amplify,
  auth,
  amplifyConfig,
}: {
  amplify: {
    configure: (config: Record<string, string>) => {};
  };
  auth: IAuthLib;
  amplifyConfig: {
    amplifyConfigData: IAmplifyConfigData;
    amplifyConfigDataNewSetUp: IAmplifyConfigDataNewSetUp;
    amplifyGoConfigData: IAmplifyGoConfigData;
    amplifySSOConfigData: IAmplifySSOConfigData;
    amplifyZpaxSSOConfigData: IAmplifyZpaxSSOConfigData;
    amplifyMicrosoftSSOConfigData: IAmplifyMicrosoftSSOConfigData;
  };
}) => {
  const {
    amplifyConfigDataNewSetUp,
    amplifyConfigData,
    amplifyGoConfigData,
    amplifySSOConfigData,
    amplifyZpaxSSOConfigData,
    amplifyMicrosoftSSOConfigData,
  } = amplifyConfig;
  const amplifyConfigure = (type = "fast") => {
    let configToImplement = {};
    switch (type) {
      case configureTypes.FAST:
        configToImplement = amplifyConfigDataNewSetUp;
        break;
      case configureTypes.GO:
        configToImplement = amplifyGoConfigData;
        break;
      case configureTypes.LAMBDA:
        configToImplement = amplifyConfigData;
        break;
      case configureTypes.SSO:
        configToImplement = amplifySSOConfigData;
        break;
      case configureTypes.ZPAX_SSO:
        configToImplement = amplifyZpaxSSOConfigData;
        break;
      case configureTypes.MICROSOFT_SSO:
        configToImplement = amplifyMicrosoftSSOConfigData;
        break;
      default:
        configToImplement = amplifyConfigDataNewSetUp;
        break;
    }

    amplify.configure(configToImplement);
    return auth.configure(configToImplement);
  };

  return {
    amplifyConfigure,
    auth,
  };
};
